export default __webpack_public_path__ + "static/media/fauna-abac-runas-requests.421cc50e.png";